import React from 'react';
import PropTypes from 'prop-types';

export const INTRO_LAYOUT_VARIANTS = {
  FULL: 'FULL',
  PORTRAITS_2: 'PORTRAITS_2',
  LANDSCAPES_2: 'LANDSCAPES_2',
  PORTRAITS_3: 'PORTRAITS_3',
  LANDSCAPES_3: 'LANDSCAPES_3',
  LANDSCAPES_4: 'LANDSCAPES_4',
};

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  variant: PropTypes.oneOf(Object.values(INTRO_LAYOUT_VARIANTS)),
};

const IntroLayoutIcon = ({
  color = '#1A2E34',
  size = 24,
  variant,
  ...props
}) => {
  switch (variant) {
    case INTRO_LAYOUT_VARIANTS.FULL:
      return (
        <svg
          viewBox="0 0 25 25"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.37 1.358h12.17a5.371 5.371 0 0 1 5.37 5.373v12.18a5.371 5.371 0 0 1-5.37 5.373H6.37A5.371 5.371 0 0 1 1 18.91V6.731a5.371 5.371 0 0 1 5.37-5.373Z"
            stroke={color}
            strokeWidth="1.075"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      );
    case INTRO_LAYOUT_VARIANTS.LANDSCAPES_2:
      return (
        <svg
          viewBox="0 0 25 25"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M.91 18.627V6.447a5.371 5.371 0 0 1 5.368-5.372h12.17a5.371 5.371 0 0 1 5.37 5.373v12.179A5.371 5.371 0 0 1 18.448 24H6.279A5.371 5.371 0 0 1 .91 18.627Zm.178-6.269H23.64"
            stroke={color}
            strokeWidth="1.075"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      );
    case INTRO_LAYOUT_VARIANTS.PORTRAITS_3:
      return (
        <svg
          viewBox="0 0 25 25"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M6.188 1.358h12.17a5.371 5.371 0 0 1 5.37 5.373v12.18a5.371 5.371 0 0 1-5.37 5.373H6.188a5.371 5.371 0 0 1-5.37-5.374V6.731a5.371 5.371 0 0 1 5.37-5.373Zm2.264.18v22.566m8-22.567v22.567"
            stroke={color}
            strokeWidth="1.075"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      );
    case INTRO_LAYOUT_VARIANTS.LANDSCAPES_3:
      return (
        <svg
          viewBox="0 0 25 25"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M.727 6.731v12.18a5.371 5.371 0 0 0 5.37 5.373h12.17a5.371 5.371 0 0 0 5.37-5.374V6.731a5.371 5.371 0 0 0-5.37-5.373H6.097a5.371 5.371 0 0 0-5.37 5.373ZM.907 13h22.55m-11.096 0v10.746"
            stroke={color}
            strokeWidth="1.075"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      );
    case INTRO_LAYOUT_VARIANTS.LANDSCAPES_4:
      return (
        <svg
          viewBox="0 0 25 25"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M6.006 1.358h12.17a5.371 5.371 0 0 1 5.37 5.373v12.18a5.371 5.371 0 0 1-5.37 5.373H6.006a5.371 5.371 0 0 1-5.37-5.374V6.731a5.371 5.371 0 0 1 5.37-5.373Zm6.264.18v22.566M.815 13H23.01"
            stroke={color}
            strokeWidth="1.075"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      );
    default:
      return (
        <svg
          viewBox="0 0 25 25"
          width={size}
          height={size}
          xmlns="http://www.w3.org/2000/svg"
          {...props}
        >
          <path
            d="M6.37 1.358h12.17a5.371 5.371 0 0 1 5.37 5.373v12.18a5.371 5.371 0 0 1-5.37 5.373H6.37A5.371 5.371 0 0 1 1 18.91V6.731a5.371 5.371 0 0 1 5.37-5.373Zm6.264.18v22.566"
            stroke={color}
            strokeWidth="1.075"
            fill="none"
            fillRule="evenodd"
          />
        </svg>
      );
  }
};

IntroLayoutIcon.propTypes = propTypes;

export default IntroLayoutIcon;
